import InternetExplorer from './InternetExplorer';
import ErrorBox from './ErrorBox';
import Minesweeper from './Minesweeper';
import MyComputer from './MyComputer';
import Notepad from './Notepad';
import WindowsMediaPlayer, { VP_HEIGHT, VP_WIDTH } from './WindowsMediaPlayer';
import Paint from './Paint';
import EventPrompt from './EventPrompt';
import SpiralViewer, { SPIRAL_MEDIA_SIZE } from './SpiralViewer';
import error from 'assets/windowsIcons/897(16x16).png';
import iePaper from 'assets/windowsIcons/ie-paper.png';
import ie from 'assets/windowsIcons/ie.png';
import mine from 'assets/minesweeper/mine-icon.png';
import computer from 'assets/windowsIcons/676(16x16).png';
import computerLarge from 'assets/windowsIcons/676(32x32).png';
import notepad from 'assets/windowsIcons/327(16x16).png';
import notepadLarge from 'assets/windowsIcons/327(32x32).png';
import mediaPlayerSm from 'assets/windowsIcons/846(16x16).png';
import mediaPlayerLg from 'assets/windowsIcons/846(32x32).png';
import paintLarge from 'assets/windowsIcons/680(32x32).png';
import paint from 'assets/windowsIcons/680(16x16).png';
import info from 'assets/windowsIcons/505(16x16).png';

const gen = () => {
  let id = -1;
  return () => {
    id += 1;
    return id;
  };
};
const genId = gen();
const genIndex = gen();
export const defaultAppState = [
  /* #1 z — lemo cake */
  {
    component: Paint,
    header: {
      title: 'lemo cake - Paint',
      icon: paint,
    },
    defaultSize: {
      width: 520,
      height: 340,
    },
    defaultOffset: {
      x: 680,
      y: 450,
    },
    resizable: true,
    minimized: false,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
    injectProps: { imageUrl: '/paint-scene-3.png', title: 'lemo cake - Paint' },
  },
  /* #2 — half moon bay */
  {
    component: Paint,
    header: {
      title: 'half moon bay - Paint',
      icon: paint,
    },
    defaultSize: {
      width: 480,
      height: 320,
    },
    defaultOffset: {
      x: 30,
      y: 380,
    },
    resizable: true,
    minimized: false,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
    injectProps: {
      imageUrl: '/paint-scene-2.png',
      title: 'half moon bay - Paint',
    },
  },
  /* #3 — summer.exe */
  {
    component: Paint,
    header: {
      title: 'summer.exe - Paint',
      icon: paint,
    },
    defaultSize: {
      width: 550,
      height: 380,
    },
    defaultOffset: {
      x: 200,
      y: 30,
    },
    resizable: true,
    minimized: false,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
    injectProps: {
      imageUrl: '/paint-scene-1.png',
      title: 'summer.exe - Paint',
    },
  },
  /* #4 — Notepad: viewport center, 100px left of horizontal center */
  {
    component: Notepad,
    header: {
      title: 'Bermuda dpt x Design Engineers',
      icon: notepad,
    },
    defaultSize: {
      width: 500,
      height: 420,
    },
    defaultOffset: {
      x:
        typeof window !== 'undefined'
          ? Math.round((window.innerWidth - 500) / 2) - 100
          : 250,
      y:
        typeof window !== 'undefined'
          ? Math.round((window.innerHeight - 420) / 2)
          : 100,
    },
    resizable: true,
    minimized: false,
    maximized: false,
    closeAsMinimize: true,
    id: genId(),
    zIndex: genIndex(),
    injectProps: {
      richContent: `<p><strong>welcome to bermuda dpt</strong></p>

<p>we hosts creatives hours in sf.</p>

<p>where a small group of designers, engineers, and builders gather to build fun things for the internet and real world.</p>

<p>you show up with the goal of making something, and by the end of the night the person next to you is playing with it.</p>

<p>follow us on instagram: <a href="https://www.instagram.com/bermudadpt/" target="_blank" rel="noreferrer">https://www.instagram.com/bermudadpt/</a> to stay updated on our next event.</p>

<p>join our discord: <a href="https://discord.gg/kUBGQt6a" target="_blank" rel="noreferrer">https://discord.gg/kUBGQt6a</a></p>

<div class="np__ascii">                MMMM
                                                     MMMMMMMM          M
                                            MMMMMMMMMMMMMMMMMMMMMM
                                      MMMMM                 MMMMMMM
                                 MMM                         MMMMMM
                              M                               MMMM
   MMMMMMM   MMMMMM   MMMMMMM   MMMM   MMMM   MM   MMM  MMMMMMM     MMMM
   MMMMMMM   MMMMM    MM   MM   MM MM MM MM   MM   MMM  MM  M MM   MM  MM
   MM   MM   MM       MMM MMM   MM  MMMM MM   MM   MM   MM  M MM  MMMMMMMM
   MMMMMMM   MMMMMM   MM    MM  MM  MMM  MM    MMMMM    MMMMMM    MM    MM
           MM                                         MM
         MMM              MMMMM      MMMM    MMM  MM
      MMMM                MM   MM   MM   MM    MMM
    MMMM                  MM    MM  MMMMMMM  M  MM
   MMMM                   MM  MMM   MM  MM      MM     MM
 MMMMM                              MM                 M
MMMMMM                           MM
MMMMMMM                   MMMMM
 MMMMMMMMMMM   MMMMMMMMMM
   MMMMMMMMMMMMMMM

           Bermuda DPT — Creative Direction &amp; Design Engineering
                         bermudadpt.com | SF, CA

                              Version 1.0</div>`,
    },
  },
  /* #5 — Internet Explorer */
  {
    component: InternetExplorer,
    header: {
      title: 'Microsoft Internet Explorer',
      icon: iePaper,
    },
    defaultSize: {
      width: 700,
      height: 500,
    },
    defaultOffset: {
      x: window.innerWidth - 700 - 40,
      y: window.innerHeight - 500 - 40,
    },
    resizable: true,
    minimized: false,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
  },
  /* #6 — Windows Media Player: top right */
  {
    component: WindowsMediaPlayer,
    header: {
      title: 'Videos',
      icon: mediaPlayerSm,
    },
    defaultSize: {
      width: VP_WIDTH,
      height: VP_HEIGHT,
    },
    defaultOffset: {
      x:
        typeof window !== 'undefined'
          ? Math.max(24, window.innerWidth - VP_WIDTH - 24)
          : 24,
      y: 24,
    },
    resizable: true,
    minimized: false,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
  },
  /* #7 — Event prompt */
  {
    component: EventPrompt,
    header: {
      title: 'Помощь',
      icon: info,
    },
    defaultSize: {
      width: 360,
      height: 140,
    },
    defaultOffset: {
      x:
        typeof window !== 'undefined'
          ? Math.max(24, Math.round(window.innerWidth / 2 - 180))
          : 400,
      y:
        typeof window !== 'undefined'
          ? Math.max(24, window.innerHeight - 220)
          : 500,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    closeAsMinimize: true,
    id: genId(),
    zIndex: genIndex(),
  },
  /* #8 — ASCII spiral (454×454 media, bottom-left) */
  {
    component: SpiralViewer,
    header: {
      title: 'distorted future',
      icon: mediaPlayerSm,
    },
    defaultSize: {
      width: SPIRAL_MEDIA_SIZE + 6,
      height: SPIRAL_MEDIA_SIZE + 25 + 6,
    },
    defaultOffset: {
      x: 12,
      y:
        typeof window !== 'undefined'
          ? window.innerHeight - 30 - (SPIRAL_MEDIA_SIZE + 25 + 6)
          : 120,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    id: genId(),
    zIndex: genIndex(),
  },
];

export const defaultIconState = [
  {
    id: 0,
    icon: ie,
    title: 'Internet Explorer',
    component: InternetExplorer,
    isFocus: false,
  },
  {
    id: 1,
    icon: mine,
    title: 'Minesweeper',
    component: Minesweeper,
    isFocus: false,
  },
  {
    id: 2,
    icon: computerLarge,
    title: 'My Computer',
    component: MyComputer,
    isFocus: false,
  },
  {
    id: 3,
    icon: notepadLarge,
    title: 'Notepad',
    component: Notepad,
    isFocus: false,
  },
  {
    id: 4,
    icon: mediaPlayerLg,
    title: 'Videos',
    component: WindowsMediaPlayer,
    isFocus: false,
  },
  {
    id: 5,
    icon: paintLarge,
    title: 'Paint',
    component: Paint,
    isFocus: false,
  },
];

export const appSettings = {
  'Internet Explorer': {
    header: {
      icon: iePaper,
      title: 'InternetExplorer',
    },
    component: InternetExplorer,
    defaultSize: {
      width: 700,
      height: 500,
    },
    defaultOffset: {
      x: 140,
      y: 30,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  Minesweeper: {
    header: {
      icon: mine,
      title: 'Minesweeper',
    },
    component: Minesweeper,
    defaultSize: {
      width: 0,
      height: 0,
    },
    defaultOffset: {
      x: 190,
      y: 180,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  EventPrompt: {
    header: {
      icon: info,
      title: 'Помощь',
    },
    component: EventPrompt,
    defaultSize: {
      width: 360,
      height: 140,
    },
    defaultOffset: {
      x: 280,
      y: 200,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    closeAsMinimize: true,
    multiInstance: false,
  },
  Error: {
    header: {
      icon: error,
      title: 'C:\\',
      buttons: ['close'],
      noFooterWindow: true,
    },
    component: ErrorBox,
    defaultSize: {
      width: 380,
      height: 0,
    },
    defaultOffset: {
      x: window.innerWidth / 2 - 190,
      y: window.innerHeight / 2 - 60,
    },
    resizable: false,
    minimized: false,
    maximized: false,
    multiInstance: true,
  },
  'My Computer': {
    header: {
      icon: computer,
      title: 'My Computer',
    },
    component: MyComputer,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 260,
      y: 50,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: false,
  },
  Notepad: {
    header: {
      icon: notepad,
      title: 'Untitled - Notepad',
    },
    component: Notepad,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 270,
      y: 60,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
  'Windows Media Player': {
    header: {
      icon: mediaPlayerSm,
      title: 'Videos',
    },
    component: WindowsMediaPlayer,
    defaultSize: {
      width: VP_WIDTH,
      height: VP_HEIGHT,
    },
    defaultOffset: {
      x:
        typeof window !== 'undefined'
          ? Math.max(24, window.innerWidth - VP_WIDTH - 24)
          : 24,
      y: 24,
    },
    resizable: true,
    minimized: false,
    maximized: false,
    multiInstance: false,
  },
  Paint: {
    header: {
      icon: paint,
      title: 'Untitled - Paint',
    },
    component: Paint,
    defaultSize: {
      width: 660,
      height: 500,
    },
    defaultOffset: {
      x: 280,
      y: 70,
    },
    resizable: true,
    minimized: false,
    maximized: window.innerWidth < 800,
    multiInstance: true,
  },
};

export {
  InternetExplorer,
  ErrorBox,
  Minesweeper,
  EventPrompt,
  MyComputer,
  Notepad,
  WindowsMediaPlayer,
};
